import { render, staticRenderFns } from "./labelManage.vue?vue&type=template&id=7cd48000&scoped=true"
import script from "./labelManage.vue?vue&type=script&lang=js"
export * from "./labelManage.vue?vue&type=script&lang=js"
import style0 from "./labelManage.vue?vue&type=style&index=0&id=7cd48000&prod&lang=scss&scoped=true"
import style1 from "./labelManage.vue?vue&type=style&index=1&id=7cd48000&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd48000",
  null
  
)

export default component.exports